export default function Typo({Elem = 'p', children, className, ...rest}) {
    return (
        <Elem className={`text-sm leading-7 ${className ? className : ''}`} {...rest}>{children}</Elem>
    )
}
